// Library imports
import React from 'react';
// Util imports
import { scrollToTop } from '../../utils';
// Hooks
import useScreenWidth from '../../utils/hooks/useScreenWidth';
// Constants
import { MOBILE_SCREEN_SIZE } from '../../utils/constants';

const BackToTop = () => {
    const screenWidth = useScreenWidth();

    if (screenWidth > MOBILE_SCREEN_SIZE) return null;

    return (
        <button
            onClick={() => scrollToTop()}
            style={{
                position: 'fixed',
                bottom: '2rem',
                right: '1rem',
                zIndex: 1000,
                borderRadius: '50px',
                backgroundColor: 'rgba(0,0,0,0.4)',
                color: '#fff',
                border: 'none',
                padding: '0.75rem 1rem',
                cursor: 'pointer',
                fontSize: '1rem',
            }}
        >
            ↑
        </button>
    );
};

export default BackToTop;
